module.exports = __webpack_public_path__ + "img/kth-logo.2818e1f8.jpg";